import { EntityNote_PublicEntityType, IntermediaryReference_Public } from "shared/service/api/generated";
import { INoteDetails, NoteEditor, NoteSubject, NoteType } from ".";
import { NoteOperations } from "../enums";

export class NoteDetails implements INoteDetails {
    private allowedOperations: NoteOperations[] = [];

    constructor(
        id: number,
        createdAt: Date,
        createdBy: NoteEditor,
        modifiedAt: Date,
        modifiedBy: NoteEditor,
        entityName: string,
        entityType: EntityNote_PublicEntityType,
        entityId: number,
        intermediaryReferenceList: IntermediaryReference_Public[],
        type: NoteType,
        contactDate: Date,
        subjectRetailList: NoteSubject[],
        subjectCorpoList: NoteSubject[],
        body: string,
        allowedOperations: NoteOperations[],
    ) {
        this.id = id;
        this.createdAt = createdAt;
        this.createdBy = createdBy;
        this.modifiedAt = modifiedAt;
        this.modifiedBy = modifiedBy;
        this.entityName = entityName;
        this.entityType = entityType;
        this.entityId = entityId;
        this.intermediaryReferenceList = intermediaryReferenceList;
        this.type = type;
        this.contactDate = contactDate;
        this.subjectRetailList = subjectRetailList;
        this.subjectCorpoList = subjectCorpoList;
        this.body = body;
        this.allowedOperations = allowedOperations;
    }

    public readonly id: number;
    public readonly entityName: string;
    public readonly entityType: EntityNote_PublicEntityType;
    public readonly entityId: number;

    public readonly createdAt: Date;
    public readonly createdBy: NoteEditor;

    public readonly modifiedAt: Date;
    public readonly modifiedBy: NoteEditor;

    public readonly intermediaryReferenceList: IntermediaryReference_Public[];
    public readonly type: NoteType;
    public readonly contactDate: Date;
    public readonly subjectRetailList: NoteSubject[];
    public readonly subjectCorpoList: NoteSubject[];
    public readonly body: string;

    get canBeEdited() {
        return this.allowedOperations.includes(NoteOperations.edit);
    }

    get canBeDeleted() {
        return this.allowedOperations.includes(NoteOperations.remove);
    }
}
